import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SignInForm, SignInFormValues } from './Form';
import { FormWrapper, Page, SideImage } from './styles';
import { useAuth } from '@/hooks/useAuth';
import { useSignIn } from './hooks';
import { useToast } from '@chakra-ui/react';

export function SignIn() {
  const navigate = useNavigate();
  const toast = useToast();
  const { mutate: doSignIn } = useSignIn();
  const { signIn } = useAuth();
  const [error, setError] = useState<string>('');
  const [token, setToken] = useState<string>();

  async function onSubmit(credentials: SignInFormValues) {
    return new Promise<void>((resolve, reject) => {
      doSignIn({ ...credentials, baseURL: token || '' }, {
        onError: (e: any) => {
          toast({
            description: (e?.response?.data?.mensagem),
            duration: 2000
          });
          setError('Algo deu errado! Tente novamente mais tarde.');
          localStorage.clear();
          setTimeout(() => {
            window.location.reload()
          }, 2000)
        },
        onSuccess(response) {
          if (!response) {
            setError('Usuário ou senha incorretos');
            resolve();
            return;
          }
          const { email, autoridades , jwt: token } = response.data;
          signIn(
            email,
            token,
            autoridades
          );
          resolve();
          navigate('/painel');
        },
      });
    });
  }

  return (
    <Page>
      <SideImage />
      <FormWrapper>
        {
            <SignInForm setNewUrl={setToken} onSubmit={onSubmit} error={error} />
        }
      </FormWrapper>
    </Page>
  );
}
